import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonos } from '../data/content';
export function BonosSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="bonos" data-id="element-14" data-mp="185xmlf48zi53">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-15" data-mp="13cw0on5miic0">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-16" data-mp="yeujy8vo6v3p">
          <div data-id="element-17" data-mp="yekucmejepyj">
            <p className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.28em] text-leaf-dark" data-id="element-18" data-mp="yd06ffmqa59n">
              <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-19" data-mp="og59v2a0mey0" />
              Los 6 bonos
            </p>
            <h2 id="bonos" className="mt-4 font-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-20" data-mp="ke9zl8a3wr83">
              Todo lo que se suma sin costo
            </h2>
          </div>
          <p className="font-display text-lg font-bold text-ink" data-id="element-21" data-mp="2errr16dmu88e">
            Valor total{' '}
            <span className="text-ink/40 line-through" data-id="element-22" data-mp="29v18mcecv0jt">$53.700</span>{' '}
            <span className="ml-1 rounded-md bg-leaf px-2.5 py-1 text-white" data-id="element-23" data-mp="quwhsosep9wo">
              GRATIS
            </span>
          </p>
        </div>

        <ul className="mt-9 divide-y divide-ink/10 border-y border-ink/10" data-id="element-24" data-mp="vvsm33go6y2m">
          {bonos.map(bono => <li key={bono.numero} className="flex flex-wrap items-baseline gap-x-5 gap-y-1 py-5" data-id="element-25" data-mp="hwsylz4w8p81">
              <span className="font-display text-sm font-bold tabular-nums text-leaf-dark" data-id="element-26" data-mp="1aivkdccthar0">
                {bono.numero}
              </span>
              <div className="min-w-[240px] flex-1" data-id="element-27" data-mp="1ekh0d6kne55f">
                <h3 className="font-display text-lg font-bold text-ink" data-id="element-28" data-mp="10u3vjd31z6kb">
                  {bono.title}
                </h3>
                <p className="mt-0.5 text-[15px] text-ink/65" data-id="element-29" data-mp="15rnbqijb9tew">
                  {bono.description}
                </p>
              </div>
              <span className="font-display text-base font-bold text-ink/40 line-through" data-id="element-30" data-mp="1tg6kt0a6qa81">
                {bono.valor}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}